// extracted by mini-css-extract-plugin
export default {"wrapper":"GlobalNotifs_wrapper__L0j+5","active":"GlobalNotifs_active__JWvxd","loader":"GlobalNotifs_loader__MPX6u"};